import React from 'react';
import { Button } from '@mui/material';

interface SaveWriteoffConfigButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export const SaveWriteoffConfigButton: React.FC<SaveWriteoffConfigButtonProps> = ({
  onClick,
  isLoading = false,
  disabled = false,
}) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled || isLoading}
      sx={{ textTransform: 'none' }}
    >
      {isLoading ? 'Saving...' : 'Save Configuration'}
    </Button>
  );
};
